import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


const ElementPro = ({ index, element }) => {

    return (
        <div className='elem' key={index}>
            <img
                src={`${process.env.REACT_APP_FILE_URL}/${element?.icon}`}
                alt={element?.title}
            />
            <h6 className='bold600 grey500  mb-0'>{element?.title}</h6>
            <p className='body grey66 mt-8'>{element?.description}</p>

        </div>
    )


}


export default ElementPro;
